<div class="menu" [ngStyle]="notFlexMenu && {'width': '20em'}" id="navbar-small" >
    <ng-template ngFor let-item [ngForOf]="items" let-i="index">
        <a class="item grey" [routerLink]="item.link" [class.disabled]="item.disabled" routerLinkActive="active" [class.purpleTheme]="color == 'purple'" *checkPermission="item.permission">
            <div class="item-wrapper">
                <div class="icon-wrapper">
                    <div [ngClass]="item.disabled ? 'fill-light-grey' : 'fill-grey'" class="icon" aria-label="Profile" [inlineSVG]=item.svg></div>
                </div>
                <span class="pl-2">{{item.title | translate}} <span *ngIf="item.count >= 0">({{ item.count }})</span></span>
            </div>
        </a>
    </ng-template>
    <a *ngIf="changeViewOption" class="item grey" style="max-width: 50px;" ngbTooltip="{{'person.tabs.view' | translate}}" placement="left" container="body"  triggers="hover" tooltipClass="apc-tooltip-left" (click)="changeViewEvent.emit(true)">
        <div class="item-wrapper">
            <div class="icon-wrapper">
                <div [ngClass]="'fill-grey'" class="icon" aria-label="Profile" [inlineSVG]="'assets/ico/database-solid.svg'"></div>
            </div>
        </div>
    </a>
</div>